import { Button } from "@/components/ui/button";
import { useCookieConsentContext } from "@/contexts/CookieConsentContext";
import { cookieBannerContent } from "@/content/legalContent";

const CookieConsentBanner = () => {
  const { showBanner, acceptAll, acceptNecessary, openSettings } = useCookieConsentContext();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6">
      <div className="max-w-lg mx-auto bg-background/95 backdrop-blur-xl border border-border/60 rounded-2xl shadow-2xl p-6">
        <h3 className="text-sm font-semibold text-foreground mb-1.5">
          {cookieBannerContent.title}
        </h3>
        <p className="text-xs text-muted-foreground leading-relaxed mb-5">
          {cookieBannerContent.description}
        </p>
        <div className="flex flex-col sm:flex-row gap-2">
          <Button size="sm" onClick={acceptAll} className="flex-1 text-xs h-9">
            {cookieBannerContent.acceptAll}
          </Button>
          <Button size="sm" variant="outline" onClick={acceptNecessary} className="flex-1 text-xs h-9">
            {cookieBannerContent.acceptNecessary}
          </Button>
          <Button size="sm" variant="ghost" onClick={openSettings} className="flex-1 text-xs h-9">
            {cookieBannerContent.customize}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
